import type { ReactNode } from 'react';
import { useTheme } from '../theme/ThemeContext';
import { IconButton } from './Button';
import { IconMonitor, IconMoon, IconSun } from './icons';

/** Sticky, safe-area aware header. */
export function TopBar({ left, title, right }: { left?: ReactNode; title: ReactNode; right?: ReactNode }) {
  return (
    <header className="sticky top-0 z-30 border-b border-line/70 bg-bg/85 pt-[var(--safe-top)] backdrop-blur-md">
      <div className="mx-auto flex min-h-14 max-w-xl items-center gap-1 px-2">
        {left}
        <div className={`min-w-0 flex-1 ${left ? '' : 'pl-2'}`}>{title}</div>
        {right && <div className="flex shrink-0 items-center">{right}</div>}
      </div>
    </header>
  );
}

const labels = { system: 'Theme: system', light: 'Theme: light', dark: 'Theme: dark' } as const;

export function ThemeToggle() {
  const { preference, cycle } = useTheme();
  const next = preference === 'system' ? 'light' : preference === 'light' ? 'dark' : 'system';
  return (
    <IconButton label={`${labels[preference]}. Switch to ${next}`} onClick={cycle}>
      {preference === 'system' ? <IconMonitor /> : preference === 'light' ? <IconSun /> : <IconMoon />}
    </IconButton>
  );
}

export function Page({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <main className={`mx-auto w-full max-w-xl px-4 ${className}`}>{children}</main>;
}
